import { type UsageLogPage, usageLogPageSchema, type UsageQuery } from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

/** Dates are Jakarta calendar dates; the server widens them for LiteLLM. */
export function fetchUsageLogs(query: UsageQuery): Promise<UsageLogPage> {
  return apiRequest('/me/usage', usageLogPageSchema, {
    query: {
      startDate: query.startDate,
      endDate: query.endDate,
      page: query.page,
      pageSize: query.pageSize,
    },
  })
}
